<div class="wrapper">

  <div class="contentWrapper">

    <!-- header -->
    <div class="topContent">

      <div class="remainingSpace">
        <button class="icon-button header-icon-button" (click)="onBack()">
          <tun-arrow-back36px-icon-v5 class="icon icon-large-scaled-svg-button"></tun-arrow-back36px-icon-v5>
        </button>
      </div>

      <div class="titleContainer">

        <div class="title">
          {{(calendar == null ? 'calendar.create.title' : 'calendar.edit.enterName')  | translate }}
        </div>

      </div>

      <div class="remainingSpace"></div>

    </div>

    <div class="subTitleContainer">
      <div class="subTitle">
        {{(calendar == null ? 'calendar.create.enterName.title' : 'calendar.edit.enterName.title') | translate }}
      </div>
    </div>

    <div  class="textInput">
      <input
        #nameInput
        type="text"
        [value]="currentName"
        (input)="onNameChange($event.target.value)"
      >
    </div>

    <div class="buttonsContainer">
      <button
        class="button cancel-button" (click)="onBack()"
      >
        {{'general.button.cancel' | translate}}
      </button>

      <button
        class="button create-button" [disabled]="currentName == null || currentName == ''" (click)="onCommit()"
      >
        {{(calendar == null ? 'calendar.create.enterName.button.submit' : 'calendar.edit.enterName.button.submit')  | translate}}
      </button>
    </div>

  </div>




</div>
